import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, vModelCheckbox as _vModelCheckbox, withKeys as _withKeys, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_6 = {
  class: "filter-bar-field"
};
const _hoisted_7 = {
  class: "data-table-shell"
};
const _hoisted_8 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_9 = {
  class: "data-table min-w-[1280px]"
};
const _hoisted_10 = {
  class: "data-table-body"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "data-table-td data-table-sticky-left data-table-sticky-identity"
};
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-slate-900"
};
const _hoisted_14 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = {
  class: "flex items-center gap-3"
};
const _hoisted_17 = {
  key: 0,
  class: "w-5 h-5 text-purple-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_18 = {
  key: 1,
  class: "w-5 h-5 text-green-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_19 = {
  class: "data-table-cell-title"
};
const _hoisted_20 = {
  class: "data-table-cell-meta"
};
const _hoisted_21 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_22 = {
  class: "data-table-td text-sm"
};
const _hoisted_23 = {
  class: "flex flex-col items-start gap-1.5"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 1,
  class: "text-slate-600"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "data-table-td text-sm"
};
const _hoisted_29 = {
  class: "flex flex-col items-start gap-1.5"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  class: "data-table-td"
};
const _hoisted_34 = {
  key: 0,
  class: "flex flex-wrap gap-1.5"
};
const _hoisted_35 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_36 = {
  class: "data-table-td is-right text-sm text-slate-900 font-medium"
};
const _hoisted_37 = {
  class: "data-table-td is-right text-sm text-slate-900 font-medium"
};
const _hoisted_38 = {
  class: "data-table-td is-right text-sm text-slate-900 font-medium"
};
const _hoisted_39 = {
  class: "data-table-td is-center text-sm text-slate-600"
};
const _hoisted_40 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_46 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_47 = {
  class: "border-b border-slate-200 px-6 pt-4"
};
const _hoisted_48 = {
  class: "inline-flex rounded-lg bg-slate-100 p-1 text-sm"
};
const _hoisted_49 = {
  class: "overflow-y-auto max-h-[calc(90vh-190px)] p-6 space-y-6"
};
const _hoisted_50 = {
  key: 0,
  class: "space-y-3"
};
const _hoisted_51 = {
  key: 0,
  class: "rounded-lg border border-slate-200 p-6 text-center text-sm text-slate-500"
};
const _hoisted_52 = {
  key: 1,
  class: "rounded-lg border border-dashed border-slate-300 p-8 text-center"
};
const _hoisted_53 = {
  class: "flex items-center justify-between gap-4 px-4 py-3"
};
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
  class: "flex items-center gap-3"
};
const _hoisted_56 = {
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-50 text-sm font-semibold text-primary-600"
};
const _hoisted_57 = {
  class: "min-w-0"
};
const _hoisted_58 = {
  class: "truncate text-sm font-medium text-slate-900"
};
const _hoisted_59 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_60 = {
  class: "flex shrink-0 items-center gap-2"
};
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["onClick"];
const _hoisted_63 = {
  key: 0,
  class: "border-t border-slate-100 px-4 py-3"
};
const _hoisted_64 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_65 = {
  key: 1,
  class: "space-y-6"
};
const _hoisted_66 = {
  class: "grid grid-cols-1 gap-3 md:grid-cols-2"
};
const _hoisted_67 = ["value"];
const _hoisted_68 = {
  class: "min-w-0"
};
const _hoisted_69 = {
  class: "block text-sm font-medium text-slate-800"
};
const _hoisted_70 = {
  class: "mt-1 block text-xs text-slate-500"
};
const _hoisted_71 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_72 = ["disabled"];
const _hoisted_73 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_74 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_75 = {
  class: "overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_76 = {
  class: "p-6"
};
const _hoisted_77 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-6"
};
const _hoisted_78 = {
  class: "flex gap-2"
};
const _hoisted_79 = {
  class: "flex-1"
};
const _hoisted_80 = {
  class: "referrer-item"
};
const _hoisted_81 = {
  class: "referrer-avatar"
};
const _hoisted_82 = {
  class: "referrer-info"
};
const _hoisted_83 = {
  class: "referrer-name"
};
const _hoisted_84 = {
  class: "referrer-phone"
};
const _hoisted_85 = {
  class: "referrer-count"
};
const _hoisted_86 = {
  class: "md:col-span-2"
};
const _hoisted_87 = {
  class: "md:col-span-2"
};
const _hoisted_88 = {
  class: "md:col-span-2"
};
const _hoisted_89 = {
  class: "rounded-xl border border-slate-200 bg-slate-50 p-4"
};
const _hoisted_90 = {
  class: "flex gap-2 mb-3"
};
const _hoisted_91 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-3"
};
const _hoisted_92 = ["onClick"];
const _hoisted_93 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_94 = ["onClick"];
const _hoisted_95 = {
  key: 0,
  class: "p-6"
};
const _hoisted_96 = {
  key: 0,
  class: "space-y-6"
};
const _hoisted_97 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-6"
};
const _hoisted_98 = {
  class: "md:col-span-2"
};
const _hoisted_99 = {
  key: 1,
  class: "text-center py-12 text-slate-500"
};
const _hoisted_100 = {
  key: 1,
  class: "p-6"
};
const _hoisted_101 = {
  class: "mb-6"
};
const _hoisted_102 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_105 = ["disabled"];
const _hoisted_106 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_107 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_108 = {
  class: "overflow-y-auto max-h-[calc(90vh-140px)] p-6"
};
const _hoisted_109 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-6"
};
const _hoisted_110 = {
  class: "md:col-span-2"
};
const _hoisted_111 = {
  class: "rounded-lg border border-primary-200 bg-primary-50/60 p-4"
};
const _hoisted_112 = {
  class: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
};
const _hoisted_113 = {
  class: "text-sm font-medium text-slate-800"
};
const _hoisted_114 = ["disabled"];
const _hoisted_115 = {
  key: 0,
  class: "mt-3 flex items-start gap-3"
};
const _hoisted_116 = ["src"];
const _hoisted_117 = {
  class: "md:col-span-2"
};
const _hoisted_118 = {
  class: "md:col-span-2"
};
const _hoisted_119 = {
  class: "md:col-span-2"
};
const _hoisted_120 = {
  class: "md:col-span-2"
};
const _hoisted_121 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_122 = ["disabled"];
const _hoisted_123 = {
  class: "p-6 text-sm text-slate-600"
};
const _hoisted_124 = {
  class: "p-6 space-y-4"
};
const _hoisted_125 = {
  class: "font-medium text-slate-900"
};
const _hoisted_126 = {
  class: "flex gap-2"
};
const _hoisted_127 = {
  class: "flex-1"
};
const _hoisted_128 = {
  class: "referrer-item"
};
const _hoisted_129 = {
  class: "referrer-avatar"
};
const _hoisted_130 = {
  class: "referrer-info"
};
const _hoisted_131 = {
  class: "referrer-name"
};
const _hoisted_132 = {
  class: "referrer-phone"
};
const _hoisted_133 = {
  class: "referrer-count"
};
const _hoisted_134 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_135 = ["disabled"];
const _hoisted_136 = {
  class: "flex items-center gap-3"
};
const _hoisted_137 = {
  class: "min-w-0"
};
const _hoisted_138 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_139 = {
  key: 0,
  class: "flex min-h-[220px] items-center justify-center"
};
const _hoisted_140 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_141 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 px-4 py-3"
};
const _hoisted_142 = {
  class: "flex items-center justify-between gap-3"
};
const _hoisted_143 = {
  class: "min-w-0"
};
const _hoisted_144 = {
  class: "mt-1 truncate text-base font-semibold text-slate-900"
};
const _hoisted_145 = {
  class: "mt-0.5 text-sm text-slate-500"
};
const _hoisted_146 = {
  key: 0,
  class: "rounded-lg border border-rose-200 bg-rose-50 px-4 py-4"
};
const _hoisted_147 = {
  key: 1,
  class: "rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-4"
};
const _hoisted_148 = {
  class: "flex items-center gap-3"
};
const _hoisted_149 = ["src"];
const _hoisted_150 = {
  key: 1,
  class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-emerald-100"
};
const _hoisted_151 = {
  class: "min-w-0"
};
const _hoisted_152 = {
  class: "truncate text-base font-semibold text-slate-900"
};
const _hoisted_153 = {
  class: "mt-0.5 text-sm text-slate-600"
};
const _hoisted_154 = {
  key: 2,
  class: "rounded-lg border border-primary-200 bg-primary-50 px-4 py-4"
};
const _hoisted_155 = {
  class: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
};
const _hoisted_156 = {
  class: "flex min-w-0 items-center gap-3"
};
const _hoisted_157 = ["src"];
const _hoisted_158 = {
  key: 1,
  class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-slate-400 ring-1 ring-primary-100"
};
const _hoisted_159 = {
  class: "min-w-0"
};
const _hoisted_160 = {
  class: "truncate text-base font-semibold text-slate-900"
};
const _hoisted_161 = {
  class: "mt-0.5 text-sm text-slate-600"
};
const _hoisted_162 = ["disabled"];
const _hoisted_163 = {
  key: 3,
  class: "rounded-lg border border-slate-200 bg-white px-4 py-4"
};
const _hoisted_164 = {
  class: "flex flex-col-reverse gap-3 sm:flex-row sm:justify-end"
};
const _hoisted_165 = ["disabled"];
const _hoisted_166 = ["disabled"];
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import AppPagination from '@/components/AppPagination.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
import { CUSTOMER_GRANT_RESOURCES, normalizeCustomerGrantScopes, scopesFromCustomerGrants } from './utils/customerGrantResources.mjs';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import ProductPicker from '@/components/ProductPicker.vue';
import CustomerDetailModal from '@/components/CustomerDetailModal.vue';
import ReferrerDetailModal from '@/views/referrer/components/ReferrerDetailModal.vue';
import ReferrerFormModal from '@/components/ReferrerFormModal.vue';
import { buildChinaAreaOptions, closeChinaAreaCascaderAfterDistrict, codeTextMap, provinceData } from '@/utils/chinaAreaOptions.mjs';
import { getReferrerById, getReferrerPage, getReferrerAppUserCandidate, bindReferrerAppUserCandidate } from '@/api/referrer';
import { createCustomer, updateCustomer, bindCustomerReferrer, bindCustomerAppUser, getCustomerAppUser, getCustomerAppUserCandidate, bindCustomerAppUserCandidate, unbindCustomerAppUser, getCustomer, getCustomerPage, createCompany, updateCompany, recognizeCompanyLicense, getCompanyPage, deleteCompany, getCustomerMaterialTypes, getCustomerMaterials, getCustomerShareCapabilities, getCustomerAccessGrants, grantCustomerAccess, replaceCustomerAccessGrant, revokeCustomerAccessGrant } from '@/api/customer';
import { uploadFile } from '@/api/file';
import { getProductCategories } from '@/api/product';

// Tab state

export default {
  __name: 'CustomerManagement',
  setup(__props) {
    const CodeToText = codeTextMap;
    const route = useRoute();
    const router = useRouter();
    const activeDetailTab = ref('basic');

    // Modal state
    const showCreateModal = ref(false);
    const showDetailModal = ref(false);
    const showCompanyModal = ref(false);
    const showDeleteCompanyModal = ref(false);
    const isEdit = ref(false);
    const isCompanyEdit = ref(false);
    const selectedCustomer = ref(null);
    const companyToDelete = ref(null);
    const showReferrerDetailModal = ref(false);
    const selectedReferrerId = ref(null);
    const selectedReferrerInfo = ref(null);
    const showBindReferrerModal = ref(false);
    const referrerBindingCustomer = ref(null);
    const isBindingReferrer = ref(false);
    const appUserBindDialogVisible = ref(false);
    const appUserBindLoading = ref(false);
    const appUserBindSubmitting = ref(false);
    const appUserBindStateLoadFailed = ref(false);
    const customerAppUserBindFormRef = ref(null);
    const currentAppUserCustomer = ref(null);
    const boundCustomerAppUser = ref(null);
    const customerAppUserCandidate = ref(null);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    const showCustomerGrantModal = ref(false);
    const customerGrantTarget = ref(null);
    const customerGrantActiveTab = ref('list');
    const customerGrantRecords = ref([]);
    const customerGrantLoading = ref(false);
    const expandedGrantUserIds = ref([]);
    const editingCustomerGrantUserId = ref(null);
    const isCustomerGrantSubmitting = ref(false);

    // Referrer state
    const referrerLoading = ref(false);
    const referrerOptions = ref([]);
    const userStore = useUserStore();
    const canViewReferrer = computed(() => userStore.hasPermission('referrer:list'));

    // Filter state
    const showReferrerModal = ref(false);
    const searchKeyword = ref('');
    const selectedSource = ref('');
    const selectedLevel = ref('');
    const selectedSalespersonId = ref(null);
    const selectedProductId = ref('');
    const productCategories = ref([]);
    const tagKeyword = ref('');
    const newTag = ref('');
    const isSubmitting = ref(false);
    const isCompanyFetching = ref(false);
    const isCompanySubmitting = ref(false);
    const isLicenseOcrLoading = ref(false);
    const licenseFileInputRef = ref(null);
    const isMaterialTypesLoading = ref(false);
    const isMaterialListLoading = ref(false);
    const materialTypeCategories = ref([]);
    const customerMaterials = ref([]);
    const pagination = reactive({
      page: 1,
      size: 10,
      total: 0,
      pages: 0
    });

    // 将扁平的地区数据转换为树形结构（用于级联选择器）
    const regionTree = computed(() => buildChinaAreaOptions());

    // 省市区选择器
    const areaCodes = ref([]);
    const areaCascaderRef = ref(null);
    const handleAreaChange = value => {
      if (value && value.length >= 2) {
        const province = provinceData[value[0]] || '';
        const city = CodeToText[value[1]] || '';
        customerForm.province = province;
        customerForm.city = city;
        closeChinaAreaCascaderAfterDistrict(areaCascaderRef.value, value);
      } else {
        customerForm.province = '';
        customerForm.city = '';
        areaCodes.value = [];
      }
    };
    const customerSourceOptions = ['小红书', '政府网站', '客户转介绍', '渠道介绍', '员工自拓'];
    const defaultCustomerSource = customerSourceOptions[0];
    const availableTags = ['高价值', '复购客户', '投诉客户', 'VIP推荐', '新客户', '意向客户'];

    // Customer form
    const customerForm = reactive({
      id: null,
      name: '',
      type: '个人',
      contact: '',
      gender: '',
      phone: '',
      altPhone: '',
      idCard: '',
      email: '',
      source: defaultCustomerSource,
      referrerId: null,
      level: '普通',
      status: 0,
      province: '',
      city: '',
      address: '',
      tags: [],
      remark: '',
      contacts: [{
        name: '',
        phone: '',
        role: ''
      }],
      // Enterprise fields
      companyName: '',
      creditCode: '',
      legalPerson: '',
      companyNature: '',
      registeredCapital: '',
      establishedDate: '',
      certificationDate: '',
      companyAddress: '',
      businessScope: ''
    });
    const customerAppUserBindForm = reactive({
      customerId: null,
      phone: ''
    });
    const customerAppUserBindFormRules = {
      phone: [{
        required: true,
        message: '请输入APP用户手机号',
        trigger: 'blur'
      }, {
        pattern: /^1[3-9]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }]
    };
    const companyForm = reactive({
      id: null,
      companyName: '',
      socialCreditCode: '',
      legalPerson: '',
      registeredCapital: '',
      establishmentDate: '',
      registeredAddress: '',
      businessScope: '',
      licenseUrl: '',
      licensePreviewUrl: '',
      remark: ''
    });
    const grantResourceOptions = CUSTOMER_GRANT_RESOURCES;
    const customerGrantForm = reactive({
      targetUserIds: [],
      resourceScopes: []
    });
    const scopeLabelMap = grantResourceOptions.reduce((result, resource) => {
      result[resource.scope] = resource.label;
      return result;
    }, {});
    const companyPagination = reactive({
      page: 1,
      size: 10,
      total: 0,
      pages: 0
    });
    const levelValueMap = {
      普通: 0,
      高级: 1,
      重要: 1,
      VIP: 2
    };
    const levelLabelMap = {
      0: '普通',
      1: '高级',
      2: 'VIP'
    };
    const genderValueMap = {
      男: 0,
      女: 1,
      未知: 2
    };
    const genderLabelMap = {
      0: '男',
      1: '女',
      2: '未知'
    };
    const resetCustomerGrantForm = () => {
      customerGrantForm.targetUserIds = [];
      customerGrantForm.resourceScopes = [];
      editingCustomerGrantUserId.value = null;
    };
    const clearCustomerGrantResources = () => {
      customerGrantForm.resourceScopes = [];
    };
    const scopeLabel = scope => scopeLabelMap[scope] || scope;
    const grantUserInitial = record => String(record.userName || record.username || record.userId || '?').charAt(0);
    const grantResourceCount = record => scopesFromCustomerGrants(record?.grants).length;
    const loadCustomerAccessGrants = async () => {
      if (!customerGrantTarget.value?.id) return;
      customerGrantLoading.value = true;
      try {
        const result = await getCustomerAccessGrants(customerGrantTarget.value.id);
        customerGrantRecords.value = result?.records || [];
      } catch (error) {
        ElMessage.error(error?.message || '获取授权用户失败');
      } finally {
        customerGrantLoading.value = false;
      }
    };
    const toggleGrantUser = userId => {
      const index = expandedGrantUserIds.value.findIndex(id => String(id) === String(userId));
      if (index >= 0) {
        expandedGrantUserIds.value.splice(index, 1);
      } else {
        expandedGrantUserIds.value.push(userId);
      }
    };
    const openCreateCustomerGrant = () => {
      resetCustomerGrantForm();
      customerGrantActiveTab.value = 'form';
    };
    const fillCustomerGrantFormFromRecord = record => {
      resetCustomerGrantForm();
      editingCustomerGrantUserId.value = record.userId;
      customerGrantForm.targetUserIds = [record.userId];
      customerGrantForm.resourceScopes = scopesFromCustomerGrants(record.grants);
    };
    const openEditCustomerGrant = record => {
      fillCustomerGrantFormFromRecord(record);
      customerGrantActiveTab.value = 'form';
    };
    const buildCustomerGrantPayload = () => ({
      customerId: customerGrantTarget.value?.id,
      targetUserIds: customerGrantForm.targetUserIds,
      targetUserId: editingCustomerGrantUserId.value || customerGrantForm.targetUserIds[0],
      resourceScopes: normalizeCustomerGrantScopes(customerGrantForm.resourceScopes)
    });
    const openCustomerGrantModal = customer => {
      if (!customer?.canManageShares) return;
      customerGrantTarget.value = customer;
      resetCustomerGrantForm();
      customerGrantActiveTab.value = 'list';
      expandedGrantUserIds.value = [];
      showCustomerGrantModal.value = true;
      loadCustomerAccessGrants();
    };
    const closeCustomerGrantModal = () => {
      showCustomerGrantModal.value = false;
      customerGrantTarget.value = null;
      customerGrantRecords.value = [];
      expandedGrantUserIds.value = [];
      resetCustomerGrantForm();
    };
    const handleSubmitCustomerGrant = async () => {
      const payload = buildCustomerGrantPayload();
      if (!payload.customerId) {
        ElMessage.warning('请选择客户');
        return;
      }
      if (!payload.targetUserIds.length) {
        ElMessage.warning('请选择授权用户');
        return;
      }
      if (!payload.resourceScopes.length) {
        ElMessage.warning('请选择资源');
        return;
      }
      isCustomerGrantSubmitting.value = true;
      try {
        if (editingCustomerGrantUserId.value) {
          await replaceCustomerAccessGrant({
            customerId: payload.customerId,
            targetUserId: payload.targetUserId,
            resourceScopes: payload.resourceScopes
          });
          ElMessage.success('授权已修改');
        } else {
          await grantCustomerAccess({
            customerId: payload.customerId,
            targetUserIds: payload.targetUserIds,
            resourceScopes: payload.resourceScopes
          });
          ElMessage.success('授权成功');
        }
        await loadCustomerAccessGrants();
        customerGrantActiveTab.value = 'list';
        resetCustomerGrantForm();
      } catch (error) {
        ElMessage.error(error?.message || '授权保存失败');
      } finally {
        isCustomerGrantSubmitting.value = false;
      }
    };
    const handleRevokeCustomerGrant = async record => {
      try {
        await ElMessageBox.confirm(`确认解除 ${record.userName || record.username || record.userId} 在当前客户下的全部手动授权？该操作不会影响 OWNER、MANAGER、PARTNER、订单执行人等角色授权。`, '解除授权', {
          confirmButtonText: '解除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await revokeCustomerAccessGrant({
          customerId: customerGrantTarget.value?.id,
          targetUserIds: [record.userId],
          reason: '解除手动授权'
        });
        ElMessage.success('授权已解除');
        await loadCustomerAccessGrants();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error?.message || '解除授权失败');
        }
      }
    };
    let referrerSearchTimer = null;
    const searchReferrers = keyword => {
      if (referrerSearchTimer) {
        clearTimeout(referrerSearchTimer);
      }
      referrerSearchTimer = setTimeout(async () => {
        referrerLoading.value = true;
        try {
          const params = {
            page: 1,
            size: 20
          };
          if (keyword) {
            if (/^\d+$/.test(keyword)) {
              params.phone = keyword;
            } else {
              params.name = keyword;
            }
          }
          const result = await getReferrerPage(params);
          referrerOptions.value = result?.records || [];
        } catch (error) {
          console.error('搜索引入人失败:', error);
          referrerOptions.value = [];
        } finally {
          referrerLoading.value = false;
        }
      }, 300);
    };

    // 引入人搜索方法 - el-select 远程搜索使用
    const queryReferrerSearch = queryString => {
      searchReferrers(queryString);
    };
    const promptBindCandidateAfterCreate = async referrer => {
      if (!referrer?.id) return;
      let candidate = null;
      try {
        candidate = await getReferrerAppUserCandidate(referrer.id);
      } catch (error) {
        console.error('查询新建引入人匹配APP用户失败:', error);
        return;
      }
      if (!candidate) return;
      try {
        const candidateName = candidate.nickname || '未设置昵称';
        const candidatePhone = candidate.phone || referrer.phone || '-';
        await ElMessageBox.confirm(`检测到相同手机号的APP用户「${candidateName}」（${candidatePhone}），是否需要直接绑定？`, '绑定APP用户', {
          confirmButtonText: '直接绑定',
          cancelButtonText: '暂不绑定',
          type: 'info'
        });
        await bindReferrerAppUserCandidate(referrer.id);
        ElMessage.success('绑定成功');
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          console.error('创建后快速绑定APP用户失败:', error);
          ElMessage.error(error.message || '绑定APP用户失败');
        }
      }
    };
    const handleReferrerSuccess = async event => {
      if (event?.action === 'create') {
        fillReferrerToForm(event?.referrer);
        await promptBindCandidateAfterCreate(event?.referrer);
      }
    };

    // 新增引入人时发现相同引入人，选择已有引入人后直接回填到引入人选择框
    const handleSelectExistingReferrer = referrer => {
      fillReferrerToForm(referrer);
    };
    const promptBindCustomerAppUserAfterCreate = async customer => {
      if (!customer?.id) return;
      let candidate = null;
      try {
        candidate = await getCustomerAppUserCandidate(customer.id);
      } catch (error) {
        console.error('查询新建客户匹配APP用户失败:', error);
        return;
      }
      if (!candidate) return;
      try {
        const candidateName = candidate.nickname || '未设置昵称';
        const candidatePhone = candidate.phone || customer.phone || '-';
        await ElMessageBox.confirm(`检测到相同手机号的APP用户「${candidateName}」（${candidatePhone}），是否需要直接绑定？`, '绑定APP用户', {
          confirmButtonText: '直接绑定',
          cancelButtonText: '暂不绑定',
          type: 'info'
        });
        await bindCustomerAppUserCandidate(customer.id);
        ElMessage.success('绑定成功');
        await loadCustomers();
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          console.error('创建客户后快速绑定APP用户失败:', error);
          ElMessage.error(error.message || '绑定APP用户失败');
        }
      }
    };
    const handleReferrerClear = () => {
      customerForm.referrerId = null;
      referrerOptions.value = [];
    };
    const onReferrerFocus = () => {
      if (referrerOptions.value.length === 0) {
        searchReferrers('');
      }
    };
    const syncReferrerDisplayToForm = (data = {}) => {
      customerForm.referrerId = data.referrerId || null;
    };
    const fillReferrerToForm = referrer => {
      if (!referrer?.id) {
        handleReferrerClear();
        return;
      }
      customerForm.referrerId = referrer.id;
      referrerOptions.value = [referrer];
    };
    const fetchReferrerById = async id => {
      if (!id) return undefined;
      try {
        return await getReferrerById(id);
      } catch (error) {
        console.error('获取引入人信息失败:', error);
        return undefined;
      }
    };
    const normalizeLevelLabel = (levelName, level) => {
      if (levelName) {
        return levelName === '重要' ? '高级' : levelName;
      }
      return levelLabelMap[level] || '';
    };
    const mapCustomerFromApi = (data = {}) => {
      const type = data.companies && data.companies.length ? '企业' : '个人';
      const levelLabel = normalizeLevelLabel(data.levelName, data.level);
      return {
        id: data.id,
        customerNo: data.customerNo,
        name: data.name || '',
        gender: genderLabelMap[data.gender] || '',
        phone: data.phone || '',
        altPhone: data.telPhone || '',
        email: data.email || '',
        idCard: data.idCard || '',
        source: data.source || '',
        referrerId: data.referrerId,
        referrerName: data.referrerName || data.referrer?.name || '',
        level: levelLabel,
        levelValue: data.level,
        status: data.status,
        statusName: data.statusName || '',
        ownerUserId: data.ownerUserId,
        ownerUserName: data.ownerUserName || '',
        ownerUser: data.ownerUser || null,
        ownerDeptId: data.ownerDeptId,
        ownerDeptName: data.ownerDeptName || '',
        address: data.address || '',
        detailAddress: data.detailAddress || '',
        remark: data.remark || '',
        tags: Array.isArray(data.tags) ? data.tags : typeof data.tags === 'string' ? data.tags.split(',').map(tag => tag.trim()).filter(Boolean) : [],
        companies: data.companies || [],
        type,
        contact: data.referrerName || data.referrer?.name || data.ownerUserName || data.name || '-',
        isKey: data.level === 2 || data.level === 1,
        totalOrders: data.totalOrders || 0,
        totalProposals: data.totalProposals || 0,
        totalSpent: data.totalSpent || 0,
        lastFollowup: data.lastFollowup || '',
        pendingApprovalStatus: data.pendingApprovalStatus,
        pendingApprovalInstanceId: data.pendingApprovalInstanceId,
        pendingApprovalType: data.pendingApprovalType || '',
        pendingApprovalDesc: data.pendingApprovalDesc || ''
      };
    };
    const hasPendingApproval = item => item?.pendingApprovalInstanceId != null;
    const isApprovalInProgress = item => Number(item?.pendingApprovalStatus) === 0 && item?.pendingApprovalInstanceId != null;
    const isReferrerApproval = item => {
      const type = item?.pendingApprovalType || '';
      const desc = item?.pendingApprovalDesc || '';
      return type === 'customer_referrer_change_approval' || desc.includes('引入人');
    };
    const isCustomerOwnerApproval = item => {
      const type = item?.pendingApprovalType || '';
      const desc = item?.pendingApprovalDesc || '';
      return ['customer_owner_change_approval', 'customer_executor_change_approval', 'customer_assignee_change_approval'].includes(type) || desc.includes('执行人') || desc.includes('负责人') || desc.includes('规划师') || desc.includes('所属销售');
    };
    const shouldShowApprovalInReferrerColumn = item => hasPendingApproval(item) && isReferrerApproval(item);
    const shouldShowApprovalInOwnerColumn = item => hasPendingApproval(item) && (isCustomerOwnerApproval(item) || !isReferrerApproval(item));
    const openApprovalDetailModal = item => {
      if (!item?.pendingApprovalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalInstanceId.value = item.pendingApprovalInstanceId;
      showApprovalDetailModal.value = true;
    };
    const mapCompanyFromApi = (data = {}) => {
      return {
        id: data.id,
        name: data.companyName || '',
        relation: data.remark || '-',
        status: data.status,
        statusLabel: data.status === 1 ? '停用' : '正常',
        creditCode: data.socialCreditCode || '',
        legalPerson: data.legalPerson || '',
        registeredCapital: data.registeredCapital || '',
        establishedDate: data.establishmentDate || '',
        companyAddress: data.registeredAddress || '',
        businessScope: data.businessScope || '',
        licenseUrl: data.licenseUrl || '',
        licensePreviewUrl: data.licensePreviewUrl || data.licenseUrl || '',
        remark: data.remark || ''
      };
    };
    const mapCustomerToForm = (data = {}) => {
      Object.assign(customerForm, {
        id: data.id || null,
        name: data.name || '',
        type: data.type || (data.companies && data.companies.length ? '企业' : '个人'),
        contact: data.contact || '',
        gender: genderLabelMap[data.gender] || data.gender || '',
        phone: data.phone || '',
        altPhone: data.telPhone || data.altPhone || '',
        idCard: data.idCard || '',
        email: data.email || '',
        source: data.source || customerForm.source,
        referrerId: data.referrerId || null,
        level: normalizeLevelLabel(data.levelName, data.level) || data.level || '',
        status: data.status ?? 0,
        province: '',
        city: '',
        address: data.detailAddress || data.address || '',
        tags: Array.isArray(data.tags) ? data.tags : typeof data.tags === 'string' ? data.tags.split(',').map(tag => tag.trim()).filter(Boolean) : [],
        remark: data.remark || '',
        contacts: data.contacts || [{
          name: '',
          phone: '',
          role: ''
        }],
        companyName: data.companyName || '',
        creditCode: data.creditCode || '',
        legalPerson: data.legalPerson || '',
        companyNature: data.companyNature || '',
        registeredCapital: data.registeredCapital || '',
        establishedDate: data.establishedDate || '',
        certificationDate: data.certificationDate || '',
        companyAddress: data.companyAddress || '',
        businessScope: data.businessScope || ''
      });
      syncReferrerDisplayToForm(data);
    };
    const buildCustomerPayload = () => {
      const address = [customerForm.province, customerForm.city].filter(Boolean).join('');
      const levelValue = levelValueMap[customerForm.level];
      const genderValue = genderValueMap[customerForm.gender];
      return {
        name: customerForm.name?.trim(),
        gender: genderValue ?? undefined,
        phone: customerForm.phone?.trim(),
        telPhone: customerForm.altPhone?.trim() || undefined,
        email: customerForm.email?.trim() || undefined,
        idCard: customerForm.idCard?.trim() || undefined,
        source: customerForm.source || undefined,
        referrerId: customerForm.referrerId || undefined,
        level: Number.isInteger(levelValue) ? levelValue : undefined,
        status: customerForm.status ?? undefined,
        address: address || undefined,
        detailAddress: customerForm.address?.trim() || undefined,
        remark: customerForm.remark?.trim() || undefined,
        tags: customerForm.tags.length ? customerForm.tags.join(',') : undefined
      };
    };
    const resetCompanyForm = () => {
      Object.assign(companyForm, {
        id: null,
        companyName: '',
        socialCreditCode: '',
        legalPerson: '',
        registeredCapital: '',
        establishmentDate: '',
        registeredAddress: '',
        businessScope: '',
        licenseUrl: '',
        licensePreviewUrl: '',
        remark: ''
      });
    };
    const mapCompanyToForm = (data = {}) => {
      Object.assign(companyForm, {
        id: data.id || null,
        companyName: data.companyName || data.name || '',
        socialCreditCode: data.socialCreditCode || data.creditCode || '',
        legalPerson: data.legalPerson || '',
        registeredCapital: data.registeredCapital || '',
        establishmentDate: data.establishmentDate || data.establishedDate || '',
        registeredAddress: data.registeredAddress || data.companyAddress || '',
        businessScope: data.businessScope || '',
        licenseUrl: data.licenseUrl || '',
        licensePreviewUrl: data.licensePreviewUrl || data.licenseUrl || '',
        remark: data.remark || data.relation || ''
      });
    };
    const buildCompanyPayload = () => {
      return {
        customerId: selectedCustomer.value?.id,
        companyName: companyForm.companyName?.trim(),
        socialCreditCode: companyForm.socialCreditCode?.trim() || undefined,
        legalPerson: companyForm.legalPerson?.trim() || undefined,
        registeredCapital: companyForm.registeredCapital?.trim() || undefined,
        establishmentDate: companyForm.establishmentDate || undefined,
        registeredAddress: companyForm.registeredAddress?.trim() || undefined,
        businessScope: companyForm.businessScope?.trim() || undefined,
        licenseUrl: companyForm.licenseUrl?.trim() || undefined,
        remark: companyForm.remark?.trim() || undefined
      };
    };
    const applyCompanyLicenseOcrResult = (data = {}) => {
      Object.assign(companyForm, {
        companyName: data.companyName || companyForm.companyName,
        socialCreditCode: data.socialCreditCode || companyForm.socialCreditCode,
        legalPerson: data.legalPerson || companyForm.legalPerson,
        registeredCapital: data.registeredCapital || companyForm.registeredCapital,
        establishmentDate: data.establishmentDate || companyForm.establishmentDate,
        registeredAddress: data.registeredAddress || companyForm.registeredAddress,
        businessScope: data.businessScope || companyForm.businessScope
      });
    };
    const triggerLicenseUpload = () => {
      if (isLicenseOcrLoading.value) return;
      licenseFileInputRef.value?.click();
    };
    const handleLicenseFileChange = async event => {
      const file = event.target.files?.[0];
      event.target.value = '';
      if (!file) return;
      if (!/^image\/(png|jpeg|jpg)$/.test(file.type)) {
        ElMessage.warning('请上传 JPG 或 PNG 图片');
        return;
      }
      const maxSize = 7 * 1024 * 1024;
      if (file.size > maxSize) {
        ElMessage.warning('图片大小不能超过7MB');
        return;
      }
      isLicenseOcrLoading.value = true;
      try {
        const uploadResult = await uploadFile(file, 'customer-license', 'private');
        const licenseKey = uploadResult?.fileName;
        const previewUrl = uploadResult?.url;
        if (!licenseKey || !previewUrl) {
          throw new Error('上传结果缺少营业执照文件信息');
        }
        companyForm.licenseUrl = licenseKey;
        companyForm.licensePreviewUrl = previewUrl;
        const ocrResult = await recognizeCompanyLicense({
          imageUrl: previewUrl
        });
        applyCompanyLicenseOcrResult(ocrResult);
        ElMessage.success('上传并识别完成');
      } catch (error) {
        ElMessage.error(error?.message || '上传或识别失败');
      } finally {
        isLicenseOcrLoading.value = false;
      }
    };

    // Sample data
    const customers = ref([]);
    const relatedEnterprises = ref([]);
    const fetchCustomerDetail = async id => {
      if (!id) return null;
      try {
        const result = await getCustomer(id);
        return result;
      } catch (error) {
        ElMessage.error(error?.message || '获取客户详情失败');
        return null;
      }
    };
    const loadCompanies = async () => {
      const customerId = selectedCustomer.value?.id;
      if (!customerId) return;
      isCompanyFetching.value = true;
      try {
        const payload = {
          customerId,
          page: companyPagination.page,
          size: companyPagination.size
        };
        const result = await getCompanyPage(payload);
        companyPagination.page = result?.current || companyPagination.page;
        companyPagination.size = result?.size || companyPagination.size;
        companyPagination.total = result?.total || 0;
        companyPagination.pages = result?.pages || 0;
        relatedEnterprises.value = (result?.records || []).map(mapCompanyFromApi);
      } catch (error) {
        ElMessage.error(error?.message || '获取企业列表失败');
      } finally {
        isCompanyFetching.value = false;
      }
    };
    const loadMaterialTypes = async () => {
      if (isMaterialTypesLoading.value) return;
      isMaterialTypesLoading.value = true;
      try {
        const result = await getCustomerMaterialTypes();
        materialTypeCategories.value = Array.isArray(result) ? result : [];
      } catch (error) {
        ElMessage.error(error?.message || '获取资料类型失败');
      } finally {
        isMaterialTypesLoading.value = false;
      }
    };
    const loadCustomerMaterials = async () => {
      const customerId = selectedCustomer.value?.id;
      if (!customerId) return;
      isMaterialListLoading.value = true;
      try {
        const result = await getCustomerMaterials(customerId);
        customerMaterials.value = Array.isArray(result) ? result : [];
      } catch (error) {
        ElMessage.error(error?.message || '获取客户资料失败');
      } finally {
        isMaterialListLoading.value = false;
      }
    };
    const loadProductCategories = async () => {
      try {
        productCategories.value = (await getProductCategories()) || [];
      } catch (error) {
        console.error('加载产品分类失败', error);
        productCategories.value = [];
      }
    };
    const loadCustomers = async () => {
      try {
        const payload = {
          keyword: searchKeyword.value || undefined,
          level: selectedLevel.value ? levelValueMap[selectedLevel.value] : undefined,
          source: selectedSource.value || undefined,
          tags: tagKeyword.value || undefined,
          ownerUserId: selectedSalespersonId.value || undefined,
          productId: selectedProductId.value || undefined,
          page: pagination.page,
          size: pagination.size
        };
        const result = await getCustomerPage(payload);
        pagination.page = result?.current || pagination.page;
        pagination.size = result?.size || pagination.size;
        pagination.total = result?.total || 0;
        pagination.pages = result?.pages || 0;
        const pageCustomers = (result?.records || []).map(mapCustomerFromApi);
        customers.value = await loadCustomerShareCapabilities(pageCustomers);
      } catch (error) {
        ElMessage.error(error?.message || '获取客户列表失败');
      }
    };
    const loadCustomerShareCapabilities = async customerList => {
      const customersWithoutCapability = (customerList || []).map(customer => ({
        ...customer,
        canManageShares: false
      }));
      const customerIds = customersWithoutCapability.map(customer => customer.id).filter(customerId => customerId !== null && customerId !== undefined);
      if (!customerIds.length) return customersWithoutCapability;
      try {
        const result = await getCustomerShareCapabilities(customerIds);
        const capabilityMap = new Map((result?.items || []).map(item => [String(item.customerId), item.canManageShares === true]));
        return customersWithoutCapability.map(customer => ({
          ...customer,
          canManageShares: capabilityMap.get(String(customer.id)) === true
        }));
      } catch (error) {
        console.error('获取客户分享能力失败:', error);
        return customersWithoutCapability;
      }
    };
    const handleSubmitCustomer = async () => {
      if (!customerForm.name || !customerForm.phone) {
        ElMessage.warning('请输入必填项');
        return;
      }
      isSubmitting.value = true;
      try {
        const payload = buildCustomerPayload();
        if (isEdit.value) {
          const result = await updateCustomer({
            ...payload,
            id: customerForm.id
          });
          ElMessage.success(isApprovalInProgress(result) ? '已提交引入人变更审批，审批通过后生效' : '更新成功');
        } else {
          const createdCustomer = await createCustomer(payload);
          ElMessage.success('创建成功');
          showCreateModal.value = false;
          await loadCustomers();
          await promptBindCustomerAppUserAfterCreate(createdCustomer);
          return;
        }
        showCreateModal.value = false;
        await loadCustomers();
      } catch (error) {
        ElMessage.error(error?.message || '操作失败');
      } finally {
        isSubmitting.value = false;
      }
    };
    const handleSubmitCompany = async () => {
      if (!selectedCustomer.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      if (!companyForm.companyName) {
        ElMessage.warning('请输入企业名称');
        return;
      }
      isCompanySubmitting.value = true;
      try {
        const payload = buildCompanyPayload();
        if (isCompanyEdit.value) {
          await updateCompany({
            ...payload,
            id: companyForm.id
          });
          ElMessage.success('更新成功');
        } else {
          await createCompany(payload);
          ElMessage.success('创建成功');
        }
        showCompanyModal.value = false;
        await loadCompanies();
        // 更新客户对象触发子组件刷新
        const detail = await fetchCustomerDetail(selectedCustomer.value.id);
        if (detail) {
          selectedCustomer.value = {
            ...mapCustomerFromApi(detail)
          };
        }
      } catch (error) {
        ElMessage.error(error?.message || '操作失败');
      } finally {
        isCompanySubmitting.value = false;
      }
    };
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages || page === pagination.page) return;
      pagination.page = page;
      loadCustomers();
    };
    const handleSearch = () => {
      pagination.page = 1;
      loadCustomers();
    };
    const handleReset = () => {
      searchKeyword.value = '';
      tagKeyword.value = '';
      selectedSource.value = '';
      selectedLevel.value = '';
      selectedSalespersonId.value = null;
      selectedProductId.value = '';
      pagination.page = 1;
      loadCustomers();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.page = 1;
      loadCustomers();
    };

    // Computed
    const filteredCustomers = computed(() => {
      return customers.value;
    });
    const tagColorClasses = ['bg-amber-100 text-amber-800 border-amber-300', 'bg-rose-100 text-rose-800 border-rose-300', 'bg-emerald-100 text-emerald-800 border-emerald-300', 'bg-sky-100 text-sky-800 border-sky-300', 'bg-indigo-100 text-indigo-800 border-indigo-300', 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300', 'bg-lime-100 text-lime-800 border-lime-300', 'bg-orange-100 text-orange-800 border-orange-300'];
    const tagColorMap = new Map();
    const getTagClass = tag => {
      if (!tag) return tagColorClasses[0];
      if (tagColorMap.has(tag)) {
        return tagColorMap.get(tag);
      }
      const index = Math.floor(Math.random() * tagColorClasses.length);
      const colorClass = tagColorClasses[index];
      tagColorMap.set(tag, colorClass);
      return colorClass;
    };
    const toggleTag = tag => {
      const index = customerForm.tags.indexOf(tag);
      if (index > -1) {
        customerForm.tags.splice(index, 1);
      } else {
        if (customerForm.tags.length >= 10) {
          ElMessage.warning('最多只能添加10个标签');
          return;
        }
        if (tag.length > 20) {
          ElMessage.warning('单个标签最多20个字');
          return;
        }
        customerForm.tags.push(tag);
      }
    };
    const addTag = () => {
      const value = newTag.value.trim();
      if (!value) return;
      if (value.length > 20) {
        ElMessage.warning('单个标签最多20个字');
        return;
      }
      if (customerForm.tags.length >= 10) {
        ElMessage.warning('最多只能添加10个标签');
        return;
      }
      if (!customerForm.tags.includes(value)) {
        customerForm.tags.push(value);
      }
      newTag.value = '';
    };
    const openCreateModal = () => {
      isEdit.value = false;
      Object.assign(customerForm, {
        id: null,
        name: '',
        type: '个人',
        contact: '',
        gender: '',
        phone: '',
        altPhone: '',
        idCard: '',
        email: '',
        source: defaultCustomerSource,
        referrerId: null,
        level: '普通',
        status: 0,
        province: '',
        city: '',
        address: '',
        tags: [],
        remark: '',
        contacts: [{
          name: '',
          phone: '',
          role: ''
        }],
        companyName: '',
        creditCode: '',
        legalPerson: '',
        companyNature: '',
        registeredCapital: '',
        establishedDate: '',
        certificationDate: '',
        companyAddress: '',
        businessScope: ''
      });
      newTag.value = '';
      showCreateModal.value = true;
    };
    const openEditModal = async customer => {
      isEdit.value = true;
      selectedCustomer.value = customer;
      const detail = await fetchCustomerDetail(customer?.id);
      if (detail) {
        mapCustomerToForm(detail);
      } else {
        mapCustomerToForm(customer || {});
      }
      const referrer = await fetchReferrerById(customerForm.referrerId);
      if (referrer !== undefined) {
        fillReferrerToForm(referrer);
      }
      newTag.value = '';
      showCreateModal.value = true;
    };
    const handleEditCustomerFromDetail = async customer => {
      showDetailModal.value = false;
      await openEditModal(customer);
    };
    const closeCreateModal = () => {
      showCreateModal.value = false;
    };
    const openBindReferrerModal = customer => {
      referrerBindingCustomer.value = customer;
      customerForm.referrerId = null;
      referrerOptions.value = [];
      showBindReferrerModal.value = true;
    };
    const closeBindReferrerModal = () => {
      showBindReferrerModal.value = false;
      referrerBindingCustomer.value = null;
      customerForm.referrerId = null;
      referrerOptions.value = [];
    };
    const handleBindReferrer = async () => {
      if (!referrerBindingCustomer.value?.id) return;
      if (!customerForm.referrerId) {
        ElMessage.warning('请选择引入人');
        return;
      }
      isBindingReferrer.value = true;
      try {
        const customer = referrerBindingCustomer.value;
        const result = await bindCustomerReferrer(customer.id, {
          customerId: customer.id,
          referrerId: customerForm.referrerId
        });
        ElMessage.success(isApprovalInProgress(result) ? '已提交引入人变更审批，审批通过后生效' : '绑定成功');
        closeBindReferrerModal();
        await loadCustomers();
      } catch (error) {
        ElMessage.error(error?.message || '绑定失败');
      } finally {
        isBindingReferrer.value = false;
      }
    };
    const loadCustomerAppUserCandidate = async customerId => {
      customerAppUserCandidate.value = null;
      if (!customerId) return;
      try {
        const data = await getCustomerAppUserCandidate(customerId);
        customerAppUserCandidate.value = data || null;
      } catch (error) {
        customerAppUserCandidate.value = null;
        console.error('查询匹配APP用户失败:', error);
      }
    };
    const handleBindAppUserOpen = async customer => {
      currentAppUserCustomer.value = {
        ...customer
      };
      customerAppUserBindForm.customerId = customer.id;
      customerAppUserBindForm.phone = '';
      boundCustomerAppUser.value = null;
      customerAppUserCandidate.value = null;
      appUserBindStateLoadFailed.value = false;
      appUserBindDialogVisible.value = true;
      appUserBindLoading.value = true;
      try {
        const data = await getCustomerAppUser(customer.id);
        boundCustomerAppUser.value = data || null;
        if (!boundCustomerAppUser.value) {
          await loadCustomerAppUserCandidate(customer.id);
        }
      } catch (error) {
        boundCustomerAppUser.value = null;
        customerAppUserCandidate.value = null;
        appUserBindStateLoadFailed.value = true;
        console.error('获取APP用户绑定状态失败:', error);
        ElMessage.error('获取APP用户绑定状态失败，请稍后重试');
      } finally {
        appUserBindLoading.value = false;
      }
    };
    const handleBindCustomerAppUser = async () => {
      if (appUserBindStateLoadFailed.value) {
        ElMessage.error('绑定状态加载失败，请关闭后重试');
        return;
      }
      const valid = await customerAppUserBindFormRef.value.validate().catch(() => false);
      if (!valid) return;
      appUserBindSubmitting.value = true;
      try {
        await bindCustomerAppUser(currentAppUserCustomer.value.id, {
          customerId: customerAppUserBindForm.customerId,
          phone: customerAppUserBindForm.phone
        });
        ElMessage.success('绑定成功');
        appUserBindDialogVisible.value = false;
        await loadCustomers();
      } catch (error) {
        console.error('绑定APP用户失败:', error);
        ElMessage.error(error.message || '绑定APP用户失败');
      } finally {
        appUserBindSubmitting.value = false;
      }
    };
    const handleBindCustomerAppUserCandidate = async () => {
      if (!currentAppUserCustomer.value?.id) return;
      if (appUserBindStateLoadFailed.value) {
        ElMessage.error('绑定状态加载失败，请关闭后重试');
        return;
      }
      appUserBindSubmitting.value = true;
      try {
        await bindCustomerAppUserCandidate(currentAppUserCustomer.value.id);
        ElMessage.success('绑定成功');
        appUserBindDialogVisible.value = false;
        await loadCustomers();
      } catch (error) {
        console.error('快速绑定APP用户失败:', error);
        ElMessage.error(error.message || '快速绑定APP用户失败');
      } finally {
        appUserBindSubmitting.value = false;
      }
    };
    const handleUnbindCustomerAppUser = async () => {
      try {
        await ElMessageBox.confirm(`确定要解除「${currentAppUserCustomer.value?.name || '-'}」的APP用户绑定吗？`, '解除绑定', {
          confirmButtonText: '确定解除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        appUserBindSubmitting.value = true;
        await unbindCustomerAppUser(currentAppUserCustomer.value.id);
        ElMessage.success('解除绑定成功');
        boundCustomerAppUser.value = null;
        await loadCustomerAppUserCandidate(currentAppUserCustomer.value.id);
        await loadCustomers();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('解除绑定失败:', error);
          ElMessage.error(error.message || '解除绑定失败');
        }
      } finally {
        appUserBindSubmitting.value = false;
      }
    };
    const initialDetailTab = ref('basic');
    const highlightFollowId = ref(null);
    const openDetailModal = async (customer, options = {}) => {
      initialDetailTab.value = options.initialTab || 'basic';
      highlightFollowId.value = options.highlightFollowId || null;
      selectedCustomer.value = customer;
      activeDetailTab.value = 'basic';
      showDetailModal.value = true;
      companyPagination.page = 1;
      companyPagination.total = 0;
      companyPagination.pages = 0;
      relatedEnterprises.value = [];
      const detail = await fetchCustomerDetail(customer?.id);
      if (detail) {
        selectedCustomer.value = mapCustomerFromApi(detail);
      }
    };
    const openCustomerFromNotificationQuery = async () => {
      const {
        id,
        openDetail,
        tab,
        followId
      } = route.query;
      if (openDetail !== 'true' || !id) return;
      await openDetailModal({
        id: String(id)
      }, {
        initialTab: tab || 'basic',
        highlightFollowId: followId ? String(followId) : null
      });
      // 清理 query，避免刷新后重复打开
      const query = {
        ...route.query
      };
      delete query.openDetail;
      delete query.tab;
      delete query.followId;
      router.replace({
        path: route.path,
        query
      });
    };
    const openReferrerDetail = customer => {
      selectedReferrerId.value = customer.referrerId;
      selectedReferrerInfo.value = {
        referrerName: customer.referrerName,
        name: customer.referrerName,
        phone: customer.phone
      };
      showReferrerDetailModal.value = true;
    };
    const openAddEnterpriseModal = () => {
      if (!selectedCustomer.value?.id) {
        ElMessage.warning('请先选择客户');
        return;
      }
      isCompanyEdit.value = false;
      resetCompanyForm();
      showCompanyModal.value = true;
    };
    const openEditEnterpriseModal = company => {
      isCompanyEdit.value = true;
      mapCompanyToForm(company || {});
      showCompanyModal.value = true;
    };
    const closeCompanyModal = () => {
      showCompanyModal.value = false;
    };
    const handleDeleteCompany = async company => {
      if (!company?.id) return;
      companyToDelete.value = company;
      showDeleteCompanyModal.value = true;
    };
    const confirmDeleteCompany = async () => {
      const target = companyToDelete.value;
      if (!target?.id) return;
      try {
        await deleteCompany(target.id);
        ElMessage.success('删除成功');
        showDeleteCompanyModal.value = false;
        companyToDelete.value = null;
        await loadCompanies();
        // 更新客户对象触发子组件刷新
        const detail = await fetchCustomerDetail(selectedCustomer.value.id);
        if (detail) {
          selectedCustomer.value = {
            ...mapCustomerFromApi(detail)
          };
        }
      } catch (error) {
        ElMessage.error(error?.message || '删除失败');
      }
    };
    const closeDeleteCompanyModal = () => {
      showDeleteCompanyModal.value = false;
      companyToDelete.value = null;
    };
    watch([searchKeyword, tagKeyword, selectedSource, selectedLevel, selectedSalespersonId, selectedProductId], () => {
      pagination.page = 1;
      loadCustomers();
    });
    watch([activeDetailTab, () => selectedCustomer.value?.id], ([tab]) => {
      if (tab === 'enterprises') {
        companyPagination.page = 1;
        loadCompanies();
        return;
      }
      if (tab === 'documents') {
        loadMaterialTypes();
        loadCustomerMaterials();
        return;
      }
    });
    onMounted(async () => {
      loadProductCategories();
      await loadCustomers();
      await openCustomerFromNotificationQuery();
    });
    onUnmounted(() => {
      if (referrerSearchTimer) {
        clearTimeout(referrerSearchTimer);
      }
    });
    watch(() => route.query, () => {
      openCustomerFromNotificationQuery();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[53] || (_cache[53] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "客户管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理客户信息、跟进记录和客户资料")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
          to: "/referrer",
          class: "btn-outline-primary"
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          })], -1), _createTextVNode(" 引入人管理 ", -1)]))]),
          _: 1
        })), [[_directive_permission, 'referrer:list']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          onRefresh: loadCustomers
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[6] || (_cache[6] = $event => openCreateModal()),
            class: "btn-primary inline-flex items-center gap-2 whitespace-nowrap"
          }, [...(_cache[55] || (_cache[55] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新建客户 ", -1)]))])), [[_directive_permission, 'customer:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary whitespace-nowrap"
          }, " 搜索 "), _createElementVNode("button", {
            type: "button",
            onClick: handleReset,
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索客户名称、手机号、企业名称",
            class: "form-search-input form-control-sm w-full"
          }, null, 512), [[_vModelText, searchKeyword.value]]), _cache[54] || (_cache[54] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tagKeyword.value = $event),
            type: "text",
            placeholder: "按标签搜索",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, tagKeyword.value]]), _createVNode(_component_el_select, {
            modelValue: selectedSource.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectedSource.value = $event),
            placeholder: "请选择来源",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部来源",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(customerSourceOptions, source => {
              return _createVNode(_component_el_option, {
                key: source,
                label: source,
                value: source
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: selectedLevel.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedLevel.value = $event),
            placeholder: "请选择等级",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部等级",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "VIP",
              value: "VIP"
            }), _createVNode(_component_el_option, {
              label: "高级",
              value: "高级"
            }), _createVNode(_component_el_option, {
              label: "普通",
              value: "普通"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(UserSelector, {
            modelValue: selectedSalespersonId.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedSalespersonId.value = $event),
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "请选择规划师"
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(ProductPicker, {
            modelValue: selectedProductId.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectedProductId.value = $event),
            categories: productCategories.value,
            "show-label": false,
            clearable: "",
            compact: "",
            "allow-create": false
          }, null, 8, ["modelValue", "categories"])])]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[65] || (_cache[65] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-left data-table-sticky-head data-table-sticky-identity"
        }, "客户企业"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户信息"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "手机号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "引入人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "规划师"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户标签"), _createElementVNode("th", {
          class: "data-table-th is-right"
        }, "累计方案"), _createElementVNode("th", {
          class: "data-table-th is-right"
        }, "累计订单"), _createElementVNode("th", {
          class: "data-table-th is-right"
        }, "累计消费"), _createElementVNode("th", {
          class: "data-table-th is-center"
        }, "最后跟进"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomers.value, customer => {
          return _openBlock(), _createElementBlock("tr", {
            key: customer.id,
            class: "data-table-row cursor-pointer",
            onClick: $event => openDetailModal(customer)
          }, [_createElementVNode("td", _hoisted_12, [customer.companies && customer.companies.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.companies, company => {
            return _openBlock(), _createElementBlock("div", {
              key: company.id,
              class: "truncate"
            }, _toDisplayString(company.companyName), 1);
          }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
            class: _normalizeClass(['w-8 h-8 rounded-full flex items-center justify-center', customer.type === '企业' ? 'bg-purple-100' : 'bg-green-100'])
          }, [customer.type === '企业' ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[56] || (_cache[56] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[57] || (_cache[57] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          }, null, -1)]))]))], 2), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, _toDisplayString(customer.name), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(customer.source), 1)])])]), _createElementVNode("td", _hoisted_21, _toDisplayString(customer.phone), 1), _createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, [customer.referrerName && canViewReferrer.value ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "text-primary-600 hover:text-primary-700 cursor-pointer underline underline-offset-2",
            onClick: _withModifiers($event => openReferrerDetail(customer), ["stop"])
          }, _toDisplayString(customer.referrerName), 9, _hoisted_24)) : customer.referrerName ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(customer.referrerName), 1)) : _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "inline-flex h-6 items-center rounded border border-primary-200 bg-primary-50 px-2 text-xs font-medium text-primary-600 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700",
            title: "绑定引入人",
            onClick: _withModifiers($event => openBindReferrerModal(customer), ["stop"])
          }, [...(_cache[58] || (_cache[58] = [_createTextVNode(" 绑定 ", -1)]))], 8, _hoisted_26)), [[_directive_permission, 'customer:add']]), shouldShowApprovalInReferrerColumn(customer) ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "table-action-button is-purple",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: _withModifiers($event => openApprovalDetailModal(customer), ["stop"])
          }, [...(_cache[59] || (_cache[59] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_27)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_28, [_createElementVNode("div", _hoisted_29, [customer.ownerUser?.displayName || customer.ownerUserName ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(customer.ownerUser?.displayName || customer.ownerUserName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_31, "-")), shouldShowApprovalInOwnerColumn(customer) ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "table-action-button is-purple",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: _withModifiers($event => openApprovalDetailModal(customer), ["stop"])
          }, [...(_cache[60] || (_cache[60] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_32)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_33, [customer.tags && customer.tags.length ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.tags, tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: _normalizeClass(['inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs', getTagClass(tag)])
            }, _toDisplayString(tag), 3);
          }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))]), _createElementVNode("td", _hoisted_36, _toDisplayString(customer.totalProposals || 0), 1), _createElementVNode("td", _hoisted_37, _toDisplayString(customer.totalOrders), 1), _createElementVNode("td", _hoisted_38, "¥" + _toDisplayString((customer.totalSpent || 0).toLocaleString()), 1), _createElementVNode("td", _hoisted_39, _toDisplayString(customer.lastFollowup || '-'), 1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action",
            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
          }, [_createElementVNode("div", _hoisted_40, [_createElementVNode("button", {
            onClick: $event => openDetailModal(customer),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[61] || (_cache[61] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_41), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openEditModal(customer),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[62] || (_cache[62] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_42)), [[_directive_permission, 'customer:edit']]), customer.canManageShares ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => openCustomerGrantModal(customer),
            class: "table-action-button is-indigo",
            title: "客户授权",
            "aria-label": "客户授权"
          }, [...(_cache[63] || (_cache[63] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586l6.257-6.257A6 6 0 1121 9z"
          })], -1)]))], 8, _hoisted_43)) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleBindAppUserOpen(customer),
            class: "table-action-button is-primary",
            title: "绑定APP用户",
            "aria-label": "绑定APP用户"
          }, [...(_cache[64] || (_cache[64] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_44)), [[_directive_permission, 'customer:edit']])])])], 8, _hoisted_11);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(AppModal, {
          visible: showCustomerGrantModal.value,
          size: "4xl",
          onClose: closeCustomerGrantModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, [_cache[66] || (_cache[66] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "客户授权", -1)), _createElementVNode("p", _hoisted_46, _toDisplayString(customerGrantTarget.value?.name || '-') + " · " + _toDisplayString(customerGrantTarget.value?.phone || '暂无手机号'), 1)]), _createElementVNode("button", {
            onClick: closeCustomerGrantModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[67] || (_cache[67] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['rounded-md px-3 py-1.5 transition-colors', customerGrantActiveTab.value === 'list' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
            onClick: _cache[8] || (_cache[8] = $event => customerGrantActiveTab.value = 'list')
          }, " 已授权用户 ", 2), _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['rounded-md px-3 py-1.5 transition-colors', customerGrantActiveTab.value === 'form' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-500 hover:text-slate-700']),
            onClick: openCreateCustomerGrant
          }, " 新增授权 ", 2)])]), _createElementVNode("div", _hoisted_49, [customerGrantActiveTab.value === 'list' ? (_openBlock(), _createElementBlock("div", _hoisted_50, [customerGrantLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, "加载授权用户中...")) : customerGrantRecords.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_cache[68] || (_cache[68] = _createElementVNode("div", {
            class: "text-sm font-medium text-slate-700"
          }, "暂无手动授权用户", -1)), _createElementVNode("button", {
            type: "button",
            class: "mt-3 btn-primary",
            onClick: openCreateCustomerGrant
          }, "新增授权")])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(customerGrantRecords.value, record => {
            return _openBlock(), _createElementBlock("div", {
              key: record.userId,
              class: "rounded-lg border border-slate-200 bg-white"
            }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("button", {
              type: "button",
              class: "min-w-0 flex-1 text-left",
              onClick: $event => toggleGrantUser(record.userId)
            }, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, _toDisplayString(grantUserInitial(record)), 1), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, _toDisplayString(record.userName || record.username || record.userId), 1), _createElementVNode("div", _hoisted_59, _toDisplayString(record.phone || record.username || '无联系方式') + " · " + _toDisplayString(grantResourceCount(record)) + " 项资源", 1)])])], 8, _hoisted_54), _createElementVNode("div", _hoisted_60, [_createElementVNode("button", {
              type: "button",
              class: "btn-secondary px-3 py-1.5 text-xs",
              onClick: $event => openEditCustomerGrant(record)
            }, "修改", 8, _hoisted_61), _createElementVNode("button", {
              type: "button",
              class: "btn-danger-secondary px-3 py-1.5 text-xs",
              onClick: $event => handleRevokeCustomerGrant(record)
            }, "解除", 8, _hoisted_62)])]), expandedGrantUserIds.value.includes(record.userId) ? (_openBlock(), _createElementBlock("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scopesFromCustomerGrants)(record.grants), scope => {
              return _openBlock(), _createElementBlock("span", {
                key: `${record.userId}-${scope}`,
                class: "rounded-md bg-slate-100 px-2.5 py-1 text-sm text-slate-700"
              }, _toDisplayString(scopeLabel(scope)), 1);
            }), 128))])])) : _createCommentVNode("", true)]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", null, [_cache[69] || (_cache[69] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("授权用户 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(UserSelector, {
            modelValue: customerGrantForm.targetUserIds,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => customerGrantForm.targetUserIds = $event),
            multiple: !editingCustomerGrantUserId.value,
            disabled: !!editingCustomerGrantUserId.value,
            placeholder: "选择授权用户",
            class: "w-full"
          }, null, 8, ["modelValue", "multiple", "disabled"])]), _createElementVNode("div", null, [_createElementVNode("div", {
            class: "mb-3 flex items-center justify-between gap-3"
          }, [_cache[70] || (_cache[70] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700"
          }, [_createTextVNode("资源权限 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("button", {
            type: "button",
            class: "text-sm text-primary-600 hover:text-primary-700",
            onClick: clearCustomerGrantResources
          }, "清空选择")]), _createElementVNode("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grantResourceOptions), resource => {
            return _openBlock(), _createElementBlock("label", {
              key: resource.scope,
              class: _normalizeClass(['flex cursor-pointer items-start gap-3 rounded-lg border p-4 transition-colors', customerGrantForm.resourceScopes.includes(resource.scope) ? 'border-primary-400 bg-primary-50' : 'border-slate-200 bg-white hover:border-primary-300'])
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => customerGrantForm.resourceScopes = $event),
              type: "checkbox",
              class: "form-check mt-0.5",
              value: resource.scope
            }, null, 8, _hoisted_67), [[_vModelCheckbox, customerGrantForm.resourceScopes]]), _createElementVNode("span", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(resource.label), 1), _createElementVNode("span", _hoisted_70, _toDisplayString(resource.description), 1)])], 2);
          }), 128))])])]))]), _createElementVNode("div", _hoisted_71, [_createElementVNode("button", {
            onClick: closeCustomerGrantModal,
            class: "btn-secondary"
          }, "取消"), customerGrantActiveTab.value === 'form' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleSubmitCustomerGrant,
            class: "btn-primary",
            disabled: isCustomerGrantSubmitting.value
          }, _toDisplayString(isCustomerGrantSubmitting.value ? '提交中...' : editingCustomerGrantUserId.value ? '保存修改' : '保存授权'), 9, _hoisted_72)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showCreateModal.value,
          size: "4xl",
          onClose: closeCreateModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createElementVNode("h3", _hoisted_74, _toDisplayString(isEdit.value ? '编辑客户' : '新建客户'), 1), _createElementVNode("button", {
            onClick: closeCreateModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[71] || (_cache[71] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("div", null, [_cache[72] || (_cache[72] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("客户姓名 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => customerForm.name = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入客户姓名"
          }, null, 512), [[_vModelText, customerForm.name]])]), _createElementVNode("div", null, [_cache[73] || (_cache[73] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "性别", -1)), _createVNode(_component_el_select, {
            modelValue: customerForm.gender,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => customerForm.gender = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "请选择",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "男",
              value: "男"
            }), _createVNode(_component_el_option, {
              label: "女",
              value: "女"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("联系电话 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => customerForm.phone = $event),
            type: "tel",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, customerForm.phone]])]), _createElementVNode("div", null, [_cache[75] || (_cache[75] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "备用电话", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => customerForm.altPhone = $event),
            type: "tel",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, customerForm.altPhone]])]), _createElementVNode("div", null, [_cache[76] || (_cache[76] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "身份证号", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => customerForm.idCard = $event),
            type: "text",
            maxlength: "18",
            class: "form-input w-full",
            placeholder: "请输入身份证号码"
          }, null, 512), [[_vModelText, customerForm.idCard]])]), _createElementVNode("div", null, [_cache[77] || (_cache[77] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "客户邮箱", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => customerForm.email = $event),
            type: "email",
            class: "form-input w-full",
            placeholder: "请输入邮箱地址"
          }, null, 512), [[_vModelText, customerForm.email]])]), _createElementVNode("div", null, [_cache[78] || (_cache[78] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "客户来源", -1)), _createVNode(_component_el_select, {
            modelValue: customerForm.source,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => customerForm.source = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(customerSourceOptions, source => {
              return _createVNode(_component_el_option, {
                key: source,
                label: source,
                value: source
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[81] || (_cache[81] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "引入人", -1)), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createVNode(_component_el_select, {
            modelValue: customerForm.referrerId,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => customerForm.referrerId = $event),
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": queryReferrerSearch,
            loading: referrerLoading.value,
            placeholder: "搜索并选择引入人",
            class: "w-full",
            onFocus: onReferrerFocus,
            onClear: handleReferrerClear
          }, {
            prefix: _withCtx(() => [...(_cache[79] || (_cache[79] = [_createElementVNode("svg", {
              class: "w-4 h-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })], -1)]))]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referrerOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("span", null, _toDisplayString(item.name.charAt(0)), 1)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_84, _toDisplayString(item.phone), 1)]), _createElementVNode("div", _hoisted_85, " 引入 " + _toDisplayString(item.referralCount || 0) + " 人 ", 1)])]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])]), _createElementVNode("button", {
            type: "button",
            onClick: _cache[19] || (_cache[19] = $event => showReferrerModal.value = true),
            class: "btn-outline-primary"
          }, [...(_cache[80] || (_cache[80] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增 ", -1)]))])])]), _createElementVNode("div", null, [_cache[82] || (_cache[82] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "客户状态", -1)), _createVNode(_component_el_select, {
            modelValue: customerForm.status,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => customerForm.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "潜在",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "跟进中",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "正式",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "已流失",
              value: 3
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[83] || (_cache[83] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "省份/城市", -1)), _createVNode(_component_el_cascader, {
            ref_key: "areaCascaderRef",
            ref: areaCascaderRef,
            modelValue: areaCodes.value,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => areaCodes.value = $event),
            options: regionTree.value,
            placeholder: "请选择省市区",
            filterable: "",
            clearable: "",
            class: "w-full",
            onChange: handleAreaChange
          }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_86, [_cache[84] || (_cache[84] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "详细住址", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => customerForm.address = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入详细住址"
          }, null, 512), [[_vModelText, customerForm.address]])]), _createElementVNode("div", _hoisted_87, [_cache[85] || (_cache[85] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "备注信息", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => customerForm.remark = $event),
            rows: "3",
            class: "form-textarea",
            placeholder: "请输入备注信息"
          }, null, 512), [[_vModelText, customerForm.remark]])]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_cache[86] || (_cache[86] = _createElementVNode("div", {
            class: "flex items-center justify-between mb-3"
          }, [_createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "客户标签"), _createElementVNode("span", {
            class: "text-xs text-slate-500"
          }, "逐个添加，使用英文逗号分隔")], -1)), _createElementVNode("div", _hoisted_90, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => newTag.value = $event),
            type: "text",
            class: "form-input flex-1 bg-white",
            placeholder: "输入标签后点击添加",
            onKeyup: _withKeys(addTag, ["enter"])
          }, null, 544), [[_vModelText, newTag.value]]), _createElementVNode("button", {
            type: "button",
            onClick: addTag,
            class: "px-4 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 transition-colors"
          }, " 添加 ")]), customerForm.tags.length ? (_openBlock(), _createElementBlock("div", _hoisted_91, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerForm.tags, tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: _normalizeClass(['inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs', getTagClass(tag)])
            }, [_createTextVNode(_toDisplayString(tag) + " ", 1), _createElementVNode("button", {
              type: "button",
              class: "text-primary-500 hover:text-primary-700",
              onClick: $event => toggleTag(tag)
            }, "x", 8, _hoisted_92)], 2);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_93, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableTags, tag => {
            return _createElementVNode("button", {
              key: tag,
              onClick: $event => toggleTag(tag),
              class: _normalizeClass(['px-3 py-1.5 rounded-full text-xs transition-colors border', customerForm.tags.includes(tag) ? 'bg-primary-100 text-primary-700 border-primary-300' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-100'])
            }, _toDisplayString(tag), 11, _hoisted_94);
          }), 64))])])])])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_95, [customerForm.type === '企业' ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", null, [_cache[87] || (_cache[87] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "企业名称", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => customerForm.companyName = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入企业名称"
          }, null, 512), [[_vModelText, customerForm.companyName]])]), _createElementVNode("div", null, [_cache[88] || (_cache[88] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "社会统一信用代码", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => customerForm.creditCode = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入社会统一信用代码"
          }, null, 512), [[_vModelText, customerForm.creditCode]])]), _createElementVNode("div", null, [_cache[89] || (_cache[89] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "法人代表", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => customerForm.legalPerson = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入法人代表姓名"
          }, null, 512), [[_vModelText, customerForm.legalPerson]])]), _createElementVNode("div", null, [_cache[90] || (_cache[90] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "企业性质", -1)), _createVNode(_component_el_select, {
            modelValue: customerForm.companyNature,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => customerForm.companyNature = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "请选择",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "国有企业",
              value: "国有企业"
            }), _createVNode(_component_el_option, {
              label: "民营企业",
              value: "民营企业"
            }), _createVNode(_component_el_option, {
              label: "外资企业",
              value: "外资企业"
            }), _createVNode(_component_el_option, {
              label: "合资企业",
              value: "合资企业"
            }), _createVNode(_component_el_option, {
              label: "股份制企业",
              value: "股份制企业"
            }), _createVNode(_component_el_option, {
              label: "个体工商户",
              value: "个体工商户"
            }), _createVNode(_component_el_option, {
              label: "其他",
              value: "其他"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[91] || (_cache[91] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "注册资本", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => customerForm.registeredCapital = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：1000万"
          }, null, 512), [[_vModelText, customerForm.registeredCapital]])]), _createElementVNode("div", null, [_cache[92] || (_cache[92] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "成立日期", -1)), _createVNode(_component_el_date_picker, {
            modelValue: customerForm.establishedDate,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => customerForm.establishedDate = $event),
            type: "date",
            class: "w-full form-date",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择成立日期"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[93] || (_cache[93] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "认证日期", -1)), _createVNode(_component_el_date_picker, {
            modelValue: customerForm.certificationDate,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => customerForm.certificationDate = $event),
            type: "date",
            class: "w-full form-date",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择认证日期"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[94] || (_cache[94] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "企业经营地址", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => customerForm.companyAddress = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入企业经营地址"
          }, null, 512), [[_vModelText, customerForm.companyAddress]])]), _createElementVNode("div", _hoisted_98, [_cache[95] || (_cache[95] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "经营范围", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => customerForm.businessScope = $event),
            rows: "2",
            class: "form-textarea",
            placeholder: "请输入经营范围"
          }, null, 512), [[_vModelText, customerForm.businessScope]])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_99, [...(_cache[96] || (_cache[96] = [_createElementVNode("svg", {
            class: "w-12 h-12 mx-auto mb-3 text-slate-300",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1), _createElementVNode("p", null, "个人客户无需填写企业信息", -1)]))]))])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, [_cache[97] || (_cache[97] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3"
          }, "客户标签", -1)), _createElementVNode("div", _hoisted_102, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableTags, tag => {
            return _createElementVNode("button", {
              key: tag,
              onClick: $event => toggleTag(tag),
              class: _normalizeClass(['px-3 py-1.5 rounded-full text-sm transition-colors border', customerForm.tags.includes(tag) ? 'bg-primary-100 text-primary-700 border-primary-300' : 'bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-200'])
            }, _toDisplayString(tag), 11, _hoisted_103);
          }), 64))])]), _createElementVNode("div", null, [_cache[98] || (_cache[98] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3"
          }, "备注信息", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => customerForm.remark = $event),
            rows: "4",
            class: "form-textarea",
            placeholder: "请输入备注信息"
          }, null, 512), [[_vModelText, customerForm.remark]])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_104, [_createElementVNode("button", {
            onClick: closeCreateModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            disabled: isSubmitting.value,
            onClick: handleSubmitCustomer,
            class: "btn-primary"
          }, _toDisplayString(isEdit.value ? '保存修改' : '创建客户'), 9, _hoisted_105)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(CustomerDetailModal, {
          modelValue: showDetailModal.value,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => showDetailModal.value = $event),
          customer: selectedCustomer.value,
          "initial-tab": initialDetailTab.value,
          "highlight-follow-id": highlightFollowId.value,
          onOpenAddEnterprise: openAddEnterpriseModal,
          onOpenEditEnterprise: openEditEnterpriseModal,
          onEditCustomer: handleEditCustomerFromDetail,
          onDeleteCompany: handleDeleteCompany,
          onRefresh: loadCustomers
        }, null, 8, ["modelValue", "customer", "initial-tab", "highlight-follow-id"]), _createVNode(ReferrerDetailModal, {
          visible: showReferrerDetailModal.value,
          "onUpdate:visible": _cache[36] || (_cache[36] = $event => showReferrerDetailModal.value = $event),
          "referrer-id": selectedReferrerId.value,
          "referrer-info": selectedReferrerInfo.value
        }, null, 8, ["visible", "referrer-id", "referrer-info"]), _createVNode(AppModal, {
          visible: showCompanyModal.value,
          size: "3xl",
          onClose: closeCompanyModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_106, [_createElementVNode("h3", _hoisted_107, _toDisplayString(isCompanyEdit.value ? '编辑企业' : '新增企业'), 1), _createElementVNode("button", {
            onClick: closeCompanyModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[99] || (_cache[99] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_cache[103] || (_cache[103] = _createElementVNode("div", {
            class: "flex items-center justify-between gap-3 mb-2"
          }, [_createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700"
          }, "先上传营业执照自动识别")], -1)), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_113, _toDisplayString(companyForm.licenseUrl ? '已上传营业执照，可重新上传识别' : '上传图片后自动回填下方企业信息'), 1), _cache[100] || (_cache[100] = _createElementVNode("div", {
            class: "mt-1 text-xs text-slate-500"
          }, "支持 JPG、PNG，图片大小不超过 7MB。", -1))]), _createElementVNode("button", {
            type: "button",
            class: "btn-outline-primary inline-flex items-center gap-2 justify-center",
            disabled: isLicenseOcrLoading.value,
            onClick: triggerLicenseUpload
          }, [_cache[101] || (_cache[101] = _createElementVNode("svg", {
            class: "w-4 h-4 shrink-0",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 16V4m0 0l-4 4m4-4l4 4M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2"
          })], -1)), _createTextVNode(" " + _toDisplayString(isLicenseOcrLoading.value ? '识别中...' : companyForm.licenseUrl ? '重新上传识别' : '上传并识别'), 1)], 8, _hoisted_114), _createElementVNode("input", {
            ref_key: "licenseFileInputRef",
            ref: licenseFileInputRef,
            type: "file",
            accept: "image/png,image/jpeg,image/jpg",
            class: "hidden",
            onChange: handleLicenseFileChange
          }, null, 544)]), companyForm.licensePreviewUrl || companyForm.licenseUrl ? (_openBlock(), _createElementBlock("div", _hoisted_115, [_createElementVNode("img", {
            src: companyForm.licensePreviewUrl || companyForm.licenseUrl,
            alt: "营业执照",
            class: "h-20 w-32 rounded border border-slate-200 bg-white object-cover"
          }, null, 8, _hoisted_116), _cache[102] || (_cache[102] = _createElementVNode("div", {
            class: "text-xs text-slate-500 leading-5"
          }, " 识别结果会回填公司名称、统一社会信用代码、法定代表人、注册资本、成立日期、注册地址和经营范围。 ", -1))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_117, [_cache[104] || (_cache[104] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("公司名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => companyForm.companyName = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入公司名称"
          }, null, 512), [[_vModelText, companyForm.companyName]])]), _createElementVNode("div", null, [_cache[105] || (_cache[105] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "统一社会信用代码", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => companyForm.socialCreditCode = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入统一社会信用代码"
          }, null, 512), [[_vModelText, companyForm.socialCreditCode]])]), _createElementVNode("div", null, [_cache[106] || (_cache[106] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "法定代表人", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => companyForm.legalPerson = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入法定代表人"
          }, null, 512), [[_vModelText, companyForm.legalPerson]])]), _createElementVNode("div", null, [_cache[107] || (_cache[107] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "注册资本", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => companyForm.registeredCapital = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：500万"
          }, null, 512), [[_vModelText, companyForm.registeredCapital]])]), _createElementVNode("div", null, [_cache[108] || (_cache[108] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "成立日期", -1)), _createVNode(_component_el_date_picker, {
            modelValue: companyForm.establishmentDate,
            "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => companyForm.establishmentDate = $event),
            type: "date",
            class: "w-full form-date",
            format: "YYYY年MM月DD日",
            "value-format": "YYYY-MM-DD",
            placeholder: "请选择成立日期"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_118, [_cache[109] || (_cache[109] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "注册地址", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => companyForm.registeredAddress = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入注册地址"
          }, null, 512), [[_vModelText, companyForm.registeredAddress]])]), _createElementVNode("div", _hoisted_119, [_cache[110] || (_cache[110] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "经营范围", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => companyForm.businessScope = $event),
            rows: "3",
            class: "form-textarea",
            placeholder: "请输入经营范围"
          }, null, 512), [[_vModelText, companyForm.businessScope]])]), _createElementVNode("div", _hoisted_120, [_cache[111] || (_cache[111] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => companyForm.remark = $event),
            rows: "2",
            class: "form-textarea",
            placeholder: "请输入备注"
          }, null, 512), [[_vModelText, companyForm.remark]])])])]), _createElementVNode("div", _hoisted_121, [_createElementVNode("button", {
            onClick: closeCompanyModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: handleSubmitCompany,
            class: "btn-primary",
            disabled: isCompanySubmitting.value
          }, _toDisplayString(isCompanySubmitting.value ? '提交中...' : '保存'), 9, _hoisted_122)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDeleteCompanyModal.value,
          size: "md",
          scrollable: false,
          onClose: closeDeleteCompanyModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[113] || (_cache[113] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "确认删除", -1)), _createElementVNode("button", {
            onClick: closeDeleteCompanyModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[112] || (_cache[112] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_123, " 确认删除企业「" + _toDisplayString(companyToDelete.value?.name || companyToDelete.value?.companyName || '-') + "」吗？此操作不可撤销。 ", 1), _createElementVNode("div", {
            class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteCompanyModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteCompany,
            class: "btn-danger-secondary"
          }, "删除")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(ReferrerFormModal, {
          visible: showReferrerModal.value,
          "onUpdate:visible": _cache[45] || (_cache[45] = $event => showReferrerModal.value = $event),
          onSuccess: handleReferrerSuccess,
          onSelectExisting: handleSelectExistingReferrer
        }, null, 8, ["visible"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: "customer",
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id"]), _createVNode(AppModal, {
          visible: showBindReferrerModal.value,
          size: "lg",
          scrollable: false,
          onClose: closeBindReferrerModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
          }, [_cache[115] || (_cache[115] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "绑定引入人", -1)), _createElementVNode("button", {
            onClick: closeBindReferrerModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[114] || (_cache[114] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", null, [_cache[116] || (_cache[116] = _createElementVNode("div", {
            class: "text-sm text-slate-500 mb-1"
          }, "客户", -1)), _createElementVNode("div", _hoisted_125, _toDisplayString(referrerBindingCustomer.value?.name || '-'), 1)]), _createElementVNode("div", null, [_cache[119] || (_cache[119] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode("引入人 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createVNode(_component_el_select, {
            modelValue: customerForm.referrerId,
            "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => customerForm.referrerId = $event),
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": queryReferrerSearch,
            loading: referrerLoading.value,
            placeholder: "搜索并选择引入人",
            class: "w-full",
            onFocus: onReferrerFocus,
            onClear: handleReferrerClear
          }, {
            prefix: _withCtx(() => [...(_cache[117] || (_cache[117] = [_createElementVNode("svg", {
              class: "w-4 h-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })], -1)]))]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referrerOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_128, [_createElementVNode("div", _hoisted_129, [_createElementVNode("span", null, _toDisplayString(item.name.charAt(0)), 1)]), _createElementVNode("div", _hoisted_130, [_createElementVNode("div", _hoisted_131, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_132, _toDisplayString(item.phone), 1)]), _createElementVNode("div", _hoisted_133, " 引入 " + _toDisplayString(item.referralCount || 0) + " 人 ", 1)])]),
                _: 2
              }, 1032, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])]), _createElementVNode("button", {
            type: "button",
            onClick: _cache[48] || (_cache[48] = $event => showReferrerModal.value = true),
            class: "btn-outline-primary"
          }, [...(_cache[118] || (_cache[118] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增 ", -1)]))])])])]), _createElementVNode("div", _hoisted_134, [_createElementVNode("button", {
            onClick: closeBindReferrerModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: handleBindReferrer,
            class: "btn-primary",
            disabled: isBindingReferrer.value
          }, _toDisplayString(isBindingReferrer.value ? '提交中...' : '保存'), 9, _hoisted_135)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(_component_el_dialog, {
          modelValue: appUserBindDialogVisible.value,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => appUserBindDialogVisible.value = $event),
          width: "560px",
          "align-center": "",
          "close-on-click-modal": false
        }, _createSlots({
          header: _withCtx(() => [_createElementVNode("div", _hoisted_136, [_cache[121] || (_cache[121] = _createElementVNode("div", {
            class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 ring-1 ring-primary-100"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })])], -1)), _createElementVNode("div", _hoisted_137, [_cache[120] || (_cache[120] = _createElementVNode("div", {
            class: "text-lg font-semibold leading-6 text-slate-900"
          }, "绑定APP用户", -1)), _createElementVNode("div", _hoisted_138, _toDisplayString(appUserBindStateLoadFailed.value ? '绑定状态加载失败' : boundCustomerAppUser.value ? '当前客户已绑定APP用户' : '当前客户尚未绑定APP用户'), 1)])])]),
          default: _withCtx(() => [appUserBindLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_139, [...(_cache[122] || (_cache[122] = [_createElementVNode("div", {
            class: "flex flex-col items-center gap-3 text-slate-500"
          }, [_createElementVNode("div", {
            class: "app-spinner"
          }), _createElementVNode("span", {
            class: "text-sm"
          }, "加载中...")], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, [_createElementVNode("div", _hoisted_143, [_cache[123] || (_cache[123] = _createElementVNode("div", {
            class: "text-xs font-medium uppercase text-slate-500"
          }, "客户", -1)), _createElementVNode("div", _hoisted_144, _toDisplayString(currentAppUserCustomer.value?.name || '-'), 1), _createElementVNode("div", _hoisted_145, _toDisplayString(currentAppUserCustomer.value?.phone || '-'), 1)]), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-xs font-medium", boundCustomerAppUser.value ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'])
          }, _toDisplayString(boundCustomerAppUser.value ? '已绑定' : '未绑定'), 3)])]), appUserBindStateLoadFailed.value ? (_openBlock(), _createElementBlock("div", _hoisted_146, [...(_cache[124] || (_cache[124] = [_createElementVNode("div", {
            class: "flex items-start gap-3"
          }, [_createElementVNode("div", {
            class: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white text-rose-600 ring-1 ring-rose-100"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v3.75m0 3.75h.007v.008H12v-.008zM10.29 3.86L1.82 18a1.5 1.5 0 001.29 2.25h17.78A1.5 1.5 0 0022.18 18L13.71 3.86a1.5 1.5 0 00-2.42 0z"
          })])]), _createElementVNode("div", {
            class: "min-w-0"
          }, [_createElementVNode("div", {
            class: "font-semibold text-rose-700"
          }, "绑定状态加载失败"), _createElementVNode("div", {
            class: "mt-1 text-sm text-rose-600"
          }, "无法确认当前客户是否已有绑定关系，请关闭后重试。")])], -1)]))])) : boundCustomerAppUser.value ? (_openBlock(), _createElementBlock("div", _hoisted_147, [_cache[126] || (_cache[126] = _createElementVNode("div", {
            class: "mb-3 flex items-center gap-2 text-sm font-medium text-emerald-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 已绑定用户 ")], -1)), _createElementVNode("div", _hoisted_148, [boundCustomerAppUser.value.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: boundCustomerAppUser.value.avatar,
            class: "h-12 w-12 rounded-full object-cover ring-2 ring-white"
          }, null, 8, _hoisted_149)) : (_openBlock(), _createElementBlock("div", _hoisted_150, [...(_cache[125] || (_cache[125] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("div", _hoisted_151, [_createElementVNode("div", _hoisted_152, _toDisplayString(boundCustomerAppUser.value.nickname || '未设置昵称'), 1), _createElementVNode("div", _hoisted_153, _toDisplayString(boundCustomerAppUser.value.phone), 1)])])])) : customerAppUserCandidate.value ? (_openBlock(), _createElementBlock("div", _hoisted_154, [_cache[128] || (_cache[128] = _createElementVNode("div", {
            class: "mb-3 flex items-center justify-between gap-3"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-primary-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V6a4 4 0 118 0v1m-9 4h10m-8 4h6m-8 4h10a2 2 0 002-2V9a2 2 0 00-2-2H7a2 2 0 00-2 2v8a2 2 0 002 2z"
          })]), _createTextVNode(" 发现匹配用户 ")]), _createElementVNode("span", {
            class: "shrink-0 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-primary-700 ring-1 ring-primary-100"
          }, " 同手机号 ")], -1)), _createElementVNode("div", _hoisted_155, [_createElementVNode("div", _hoisted_156, [customerAppUserCandidate.value.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: customerAppUserCandidate.value.avatar,
            class: "h-12 w-12 rounded-full object-cover ring-2 ring-white"
          }, null, 8, _hoisted_157)) : (_openBlock(), _createElementBlock("div", _hoisted_158, [...(_cache[127] || (_cache[127] = [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("div", _hoisted_159, [_createElementVNode("div", _hoisted_160, _toDisplayString(customerAppUserCandidate.value.nickname || '未设置昵称'), 1), _createElementVNode("div", _hoisted_161, _toDisplayString(customerAppUserCandidate.value.phone), 1)])]), _createElementVNode("button", {
            onClick: handleBindCustomerAppUserCandidate,
            class: "btn-primary w-full shrink-0 sm:w-auto",
            type: "button",
            disabled: appUserBindSubmitting.value
          }, _toDisplayString(appUserBindSubmitting.value ? '绑定中...' : '直接绑定'), 9, _hoisted_162)])])) : _createCommentVNode("", true), !boundCustomerAppUser.value && !appUserBindStateLoadFailed.value ? (_openBlock(), _createElementBlock("div", _hoisted_163, [_cache[129] || (_cache[129] = _createElementVNode("div", {
            class: "mb-3 flex items-center gap-2 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7.5 8.25h9m-9 3.75h6m-6 3.75h9M5.25 4.5h13.5A1.5 1.5 0 0120.25 6v12a1.5 1.5 0 01-1.5 1.5H5.25A1.5 1.5 0 013.75 18V6a1.5 1.5 0 011.5-1.5z"
          })]), _createTextVNode(" 手动绑定 ")], -1)), _createVNode(_component_el_form, {
            ref_key: "customerAppUserBindFormRef",
            ref: customerAppUserBindFormRef,
            model: customerAppUserBindForm,
            rules: customerAppUserBindFormRules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "APP用户手机号",
              prop: "phone",
              class: "mb-0"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: customerAppUserBindForm.phone,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => customerAppUserBindForm.phone = $event),
                placeholder: "请输入APP用户手机号",
                maxlength: "11",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])])) : _createCommentVNode("", true)]))]),
          _: 2
        }, [!appUserBindLoading.value ? {
          name: "footer",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_164, [_createElementVNode("button", {
            onClick: _cache[50] || (_cache[50] = $event => appUserBindDialogVisible.value = false),
            class: "btn-secondary w-full sm:w-auto",
            type: "button"
          }, _toDisplayString(boundCustomerAppUser.value ? '关闭' : '取消'), 1), boundCustomerAppUser.value ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleUnbindCustomerAppUser,
            class: "btn-danger-secondary w-full sm:w-auto",
            type: "button",
            disabled: appUserBindSubmitting.value
          }, " 解除绑定 ", 8, _hoisted_165)) : _createCommentVNode("", true), !boundCustomerAppUser.value && !appUserBindStateLoadFailed.value ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: handleBindCustomerAppUser,
            class: "btn-primary w-full sm:w-auto",
            type: "button",
            disabled: appUserBindSubmitting.value
          }, _toDisplayString(appUserBindSubmitting.value ? '绑定中...' : '按手机号绑定'), 9, _hoisted_166)) : _createCommentVNode("", true)])]),
          key: "0"
        } : undefined]), 1032, ["modelValue"])]),
        _: 1
      });
    };
  }
};